import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MessageSquareText } from "lucide-react";
import { useChat } from "@/context/ChatContext";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";
import ChatPanel from "@/components/chat/ChatPanel";

// Icona 💬 Chat nella top bar + badge rosso non letti + drawer laterale.
export default function ChatButton() {
  const { totals, drawerOpen, setDrawerOpen } = useChat();
  const navigate = useNavigate();
  const location = useLocation();
  const onChatPage = location.pathname === "/chat";
  const [bump, setBump] = useState(false);
  const prevCount = useRef(totals.count);
  const hasImportant = totals.important > 0;

  // Breve animazione quando il numero di non letti aumenta (nuovo messaggio)
  useEffect(() => {
    if (totals.count > prevCount.current) {
      setBump(true);
      const t = setTimeout(() => setBump(false), 900);
      prevCount.current = totals.count;
      return () => clearTimeout(t);
    }
    prevCount.current = totals.count;
    return undefined;
  }, [totals.count]);

  return (
    <>
      <button
        type="button"
        onClick={() => (onChatPage ? navigate("/chat") : setDrawerOpen(true))}
        className={`relative flex h-10 items-center gap-2 rounded-xl border px-3.5 text-sm font-semibold shadow-sm transition-[background-color,border-color,transform,box-shadow] hover:-translate-y-px hover:shadow ${
          hasImportant
            ? "border-danger/50 bg-danger/10 text-danger hover:bg-danger/15"
            : totals.count > 0
              ? "border-brand/40 bg-brand/10 text-brand hover:bg-brand/15"
              : "border-brand/25 bg-brand/5 text-brand hover:bg-brand/10"
        } ${bump ? "chat-bump" : ""}`}
        data-testid="chat-button" title="Chat interna"
      >
        <MessageSquareText className="h-5 w-5 shrink-0" />
        <span className="hidden whitespace-nowrap sm:inline">Chat interna</span>
        {totals.count > 0 && (
          <span data-testid="chat-unread-badge"
            className={`absolute -right-2 -top-2 flex h-6 min-w-[24px] items-center justify-center rounded-full border-2 border-white bg-danger px-1.5 text-[11px] font-bold leading-none text-white shadow ${
              hasImportant ? "animate-pulse ring-4 ring-danger/30" : bump ? "chat-bump" : ""}`}>
            {totals.count > 99 ? "99+" : totals.count}
          </span>
        )}
      </button>

      <Sheet open={drawerOpen && !onChatPage} onOpenChange={setDrawerOpen}>
        <SheetContent side="right" className="flex w-full flex-col gap-3 bg-white p-4 sm:max-w-xl" data-testid="chat-drawer">
          <SheetHeader className="text-left">
            <SheetTitle className="flex items-center gap-2 font-display"><MessageSquareText className="h-5 w-5 text-brand" /> Chat interna</SheetTitle>
            <SheetDescription>
              Comunicazioni tra sedi, Back Office e Direzione.{" "}
              <button type="button" className="font-medium text-brand hover:underline" onClick={() => { setDrawerOpen(false); navigate("/chat"); }} data-testid="chat-open-page">Apri a pagina intera</button>
            </SheetDescription>
          </SheetHeader>
          <ChatPanel className="min-h-0 flex-1" />
        </SheetContent>
      </Sheet>
    </>
  );
}
